import * as localeDictionary from 'plotly.js/lib/locales/fr';
import React, { Component } from 'react';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';

const DiagrammeSankey = (props) => {
  /**
   *
   * @return {JSX.Element}
   */

  let jsonLayout = {};
  let styleData = {};
  if (props.viewobj_json_content !== undefined) {
    if (props.viewobj_json_content.layout !== undefined) {
      jsonLayout = props.viewobj_json_content.layout;
    }
    if (props.viewobj_json_content.styleData !== undefined) {
      styleData = props.viewobj_json_content.styleData;
    }
  }

  let values = [];

  for (let courbe of props.donnees) {
    if (courbe.y.length > 0) {
      values.push(courbe.y[courbe.y.length - 1]);
    } else {
      values.push(0);
    }
  }

  let data = [
    {
      type: 'sankey',
      orientation: 'h',
      node: {
        pad: 5,
        thickness: 20,
        line: {
          color: 'black',
          width: 0.5,
        },
        legend: 8,
        label: [
          'SB GROUPE',
          'SB Fondations',
          'SB Malet',
          'SB Génie civil',
          'SB Valerian',
          'SB Construction',
          'Equipement de construction routière',
          'Equipement de béton',
          'Equipement de tranchée et d excavation',
          'Equipement de démolition',
          'Equipement routier',
          'Equipement de manutention',
          'Equipement de terrassement',
          'Equipement de compactage',
          'Energie',
          'Equipement minier',
          'Equipement de forage et battage',
          'Equipement de construction spécialisé',
        ],
        color: [
          '#f0af00',
          '#f0af00',
          '#f0af00',
          '#f0af00',
          '#f0af00',
          '#f0af00',
          '#e786aa',
          '#a7a7a7',
          '#c5a289',
          '#ffa280',
          '#ffda92',
          '#80b180',
          '#8080bf',
          '#bf80bf',
          '#5e5e5e',
          '#bfbf80',
          '#ced6de',
          '#80c5c5',
        ],
      },
      link: {
        source: [
          0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2,
          2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4,
          4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        ],
        target: [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 6, 7, 8, 9,
          10, 11, 12, 13, 14, 15, 16, 17, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
          16, 17, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 6, 7, 8, 9, 10,
          11, 12, 13, 14, 15, 16, 17,
        ],

        color: [
          'rgba(240,175,0,0.60)',
          'rgba(240,175,0,0.60)',
          'rgba(240,175,0,0.60)',
          'rgba(240,175,0,0.60)',
          'rgba(240,175,0,0.60)',
          'rgba(231,134,170,0.60)',
          'rgba(167,167,167,0.60)',
          'rgba(197,162,137,0.60)',
          'rgba(255,162,128,0.60)',
          'rgba(255,218,146,0.60)',
          'rgba(128,177,128,0.60)',
          'rgba(128,128,191,0.60)',
          'rgba(191,128,191,0.60)',
          'rgba(94,94,94,0.60)',
          'rgba(191,191,128,0.60)',
          'rgba(206,214,222,0.60)',
          'rgba(128,197,197,0.60)',
          'rgba(231,134,170,0.60)',
          'rgba(167,167,167,0.60)',
          'rgba(197,162,137,0.60)',
          'rgba(255,162,128,0.60)',
          'rgba(255,218,146,0.60)',
          'rgba(128,177,128,0.60)',
          'rgba(128,128,191,0.60)',
          'rgba(191,128,191,0.60)',
          'rgba(94,94,94,0.60)',
          'rgba(191,191,128,0.60)',
          'rgba(206,214,222,0.60)',
          'rgba(128,197,197,0.60)',
          'rgba(231,134,170,0.60)',
          'rgba(167,167,167,0.60)',
          'rgba(197,162,137,0.60)',
          'rgba(255,162,128,0.60)',
          'rgba(255,218,146,0.60)',
          'rgba(128,177,128,0.60)',
          'rgba(128,128,191,0.60)',
          'rgba(191,128,191,0.60)',
          'rgba(94,94,94,0.60)',
          'rgba(191,191,128,0.60)',
          'rgba(206,214,222,0.60)',
          'rgba(128,197,197,0.60)',
          'rgba(231,134,170,0.60)',
          'rgba(167,167,167,0.60)',
          'rgba(197,162,137,0.60)',
          'rgba(255,162,128,0.60)',
          'rgba(255,218,146,0.60)',
          'rgba(128,177,128,0.60)',
          'rgba(128,128,191,0.60)',
          'rgba(191,128,191,0.60)',
          'rgba(94,94,94,0.60)',
          'rgba(191,191,128,0.60)',
          'rgba(206,214,222,0.60)',
          'rgba(128,197,197,0.60)',
          'rgba(231,134,170,0.60)',
          'rgba(167,167,167,0.60)',
          'rgba(197,162,137,0.60)',
          'rgba(255,162,128,0.60)',
          'rgba(255,218,146,0.60)',
          'rgba(128,177,128,0.60)',
          'rgba(128,128,191,0.60)',
          'rgba(191,128,191,0.60)',
          'rgba(94,94,94,0.60)',
          'rgba(191,191,128,0.60)',
          'rgba(206,214,222,0.60)',
          'rgba(128,197,197,0.60)',
        ],
        value: values,
      },
      ...styleData,
    },
  ];

  return (
    <BibliothequePlotly
      data={data}
      layout={{
        title: {
          text:
            props.configuration.title + '<br>' + props.configuration.subtitle,
        },
        responsive: true,
        width:
          props.dimensionWidth !== undefined
            ? props.dimensionWidth
            : window.innerWidth * 0.75, //150
        height:
          props.dimensionHeight !== undefined
            ? props.dimensionHeight
            : window.innerHeight * 0.85, //165
        legend: {
          x: 1.05, //todo rendre la légende responsive
          y: 1,
          borderwidth: 2,
          entrywidthmode: 'pixels',
          entrywidth: 20,
        },
        modebar: {
          // vertical modebar button layout
          orientation: 'h',
          // for demonstration purposes
          bgcolor: 'rgba(0, 0, 0, 0)',
          color: 'black',
          activecolor: '#f0af00',
        },
        ...jsonLayout,
      }}
      donneesGraphe={props.donneesGraphe}
      ouvrirPopupModifierIntervalle={props.switchAfficherModifierIntervalle}
      dimensionWidth={props.dimensionWidth}
      dimensionHeight={props.dimensionHeight}
      viewobj_json_content={props.viewobj_json_content}
      config={{
        locales: { fr: localeDictionary },
        locale: 'fr',
        displayModeBar:
          props.viewobj_json_content === undefined ||
          props.viewobj_json_content === null
            ? true
            : props.viewobj_json_content.length === 0 ||
              props.viewobj_json_content.displayModeBar === true
            ? true
            : false,
        displaylogo: false,
        modeBarButtonsToRemove: [''],
      }}
    />
  );
};

export default DiagrammeSankey;
